import { StyleProp } from "./StyleProp.mjs";
const DefaultHorizontalAlignStyle = StyleProp.defineEnum("tldraw:horizontalAlign", {
  defaultValue: "middle",
  values: ["start", "middle", "end", "start-legacy", "end-legacy", "middle-legacy"]
});
export {
  DefaultHorizontalAlignStyle
};
//# sourceMappingURL=TLHorizontalAlignStyle.mjs.map
